var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-around q-px-sm"},_vm._l((_vm.btn_data),function(btn){return _c('q-btn',{key:btn.label,staticClass:"col-sm-3 col-xs-12 q-ma-md",attrs:{"outline":"","rounded":"","stack":"","color":"primary","size":"md","icon":btn.icon,"label":btn.label},on:{"click":btn.click}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }